/* ============================================================
   TENUTA GRIECI · tg-haptics.js   —   17/10/2026
   Un colpetto di vibrazione sui pulsanti dove si decide qualcosa
   o si cambia pagina, non su ogni link:
     · la tab bar in basso (.tg-tabbar, costruita da tg-upgrades.js)
     · Menu / Chiudi e le voci del menu
     · scheda dell'olio: scelta rapida 3 · 6 · 12, "Prenota" e il
       "Prenota" della barra fissa
   Restano fuori l'indice delle sezioni della scheda (scorre la
   pagina, non la cambia) e i link nel testo.

   · Android (Chrome, Samsung Internet): navigator.vibrate, l'API
     ufficiale, con un impulso di 12 ms.
   · iPhone: Safari non ha navigator.vibrate. Si usa il metodo di
     ios-haptics 3 (github.com/tijnjh/ios-haptics, licenza MIT):
     dentro ogni pulsante c'è un interruttore <input type="checkbox"
     switch> trasparente; il dito tocca davvero l'interruttore e
     Safari dà il suo riscontro tattile nativo. Il vecchio trucco
     (clic simulato dal codice) Apple l'ha chiuso in iOS 26.5;
     questo, secondo l'autore della libreria, funziona ancora. Da
     riprovare su un iPhone vero quando esce una nuova versione di iOS.
   · Il clic arriva all'interruttore: i listener dei pulsanti partono
     lo stesso (il clic risale), ma il browser non segue più da solo
     il link né invia il modulo. Lo fa questo file, una volta sola:
     per un istante toglie href (o rende il pulsante type="button")
     così Safari non lo fa per conto suo, poi apre la pagina o invia
     il modulo, se nessun altro script ha annullato il clic.
   · tg-upgrades.js e la scheda riscrivono il testo di alcuni pulsanti
     (textContent) e così cancellano l'interruttore: un
     MutationObserver lo rimette.
   · Tastiera e VoiceOver attivano il pulsante direttamente e non
     passano di qui. Dove nessuna delle due strade c'è (computer) non
     cambia nulla.

   addSwitch() deriva da ios-haptics, che chiede di riportare qui
   la sua licenza:

   MIT License  Copyright (c) 2025 tijn

   Permission is hereby granted, free of charge, to any person obtaining
   a copy of this software and associated documentation files (the
   "Software"), to deal in the Software without restriction, including
   without limitation the rights to use, copy, modify, merge, publish,
   distribute, sublicense, and/or sell copies of the Software, and to
   permit persons to whom the Software is furnished to do so, subject to
   the following conditions:

   The above copyright notice and this permission notice (including the
   next paragraph) shall be included in all copies or substantial
   portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
   ============================================================ */
(function () {
  'use strict';
  var SEL = [
    '.tg-tabbar__btn',   /* tab bar in basso */
    '#menuToggle',       /* Menu / Chiudi */
    '.menu__item-link',  /* voci del menu */
    '.product__preset',  /* scelta rapida 3 · 6 · 12 */
    '.product__atc',     /* Prenota */
    '.tg-buybar__btn'    /* Prenota nella barra fissa */
  ].join(',');

  var IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var VIBRATE = !IOS && typeof navigator.vibrate === 'function' &&
                matchMedia('(pointer:coarse)').matches;

  /* Capture su window: tg-menu.js ferma la propagazione dei clic sul
     menu, ma i listener sullo stesso window partono comunque. */
  if (VIBRATE) {
    window.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest(SEL)) { try { navigator.vibrate(12); } catch (err) {} }
    }, true);
    return;
  }
  if (!IOS) return;

  var css = document.createElement('style');
  css.textContent =
    '[data-tg-haptic]{position:absolute;inset:0;z-index:9;width:100%;height:100%;margin:0;padding:0;' +
    'opacity:0;border-radius:inherit;touch-action:pan-x pan-y;-webkit-tap-highlight-color:transparent}' +
    ':disabled>[data-tg-haptic]{display:none}';
  document.head.appendChild(css);

  function addSwitch(host) {
    var sw = document.createElement('input');
    sw.type = 'checkbox';
    sw.setAttribute('switch', '');
    sw.setAttribute('data-tg-haptic', '');
    sw.setAttribute('aria-hidden', 'true');
    sw.tabIndex = -1;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

    /* Un gesto che parte sul pulsante e scorre la pagina non è un tocco. */
    var y0 = 0;
    sw.addEventListener('pointerdown', function (e) { y0 = e.clientY; sw.__tgMoved = false; }, { passive: true });
    sw.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientY - y0) > 10) { sw.__tgMoved = true; sw.checked = false; }
    }, { passive: true });
    sw.addEventListener('pointercancel', function () { sw.__tgMoved = true; sw.checked = false; }, { passive: true });
    /* L'interruttore sta dentro il modulo della scheda: il suo "change"
       non deve arrivare ai listener del modulo (tg-upgrades.js). */
    sw.addEventListener('change', function (e) { e.stopPropagation(); });

    host.appendChild(sw);
  }

  function arm() {
    var hosts = document.querySelectorAll(SEL);
    for (var i = 0; i < hosts.length; i++) {
      if (!hosts[i].querySelector(':scope > [data-tg-haptic]')) addSwitch(hosts[i]);
    }
  }

  window.addEventListener('click', function (e) {
    var sw = e.target;
    if (!sw || !sw.hasAttribute || !sw.hasAttribute('data-tg-haptic') || sw.__tgMoved) return;
    var host = sw.parentElement;
    if (!host) return;

    if (host.tagName === 'A' && host.hasAttribute('href')) {
      var href = host.getAttribute('href'), url = host.href;
      host.removeAttribute('href');
      setTimeout(function () {
        host.setAttribute('href', href);
        if (!e.defaultPrevented) location.assign(url);
      }, 0);
    } else if (host.type === 'submit' && host.form) {
      var form = host.form;
      host.type = 'button';
      setTimeout(function () {
        host.type = 'submit';
        if (e.defaultPrevented) return;
        if (form.requestSubmit) form.requestSubmit(host);
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      }, 0);
    }
    /* I pulsanti type="button" non hanno nulla da fare: i loro listener
       hanno già ricevuto il clic risalendo dall'interruttore. */
  }, true);

  /* tg-upgrades.js costruisce tab bar e barra "Prenota" su DOMContentLoaded
     e nel layout viene prima di questo file: il suo listener parte prima. */
  document.addEventListener('DOMContentLoaded', function () {
    arm();
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; arm(); });
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
